/**
 * Handles validation for all `Question` fields
 */
import { z } from 'zod';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';

const questionOptionSchema = z.object({
    value: z.string().min(1, 'Option value is required'),
});

export const questionObjectSchema = z.object({
    required: z.boolean().optional(),
    content: z.string().min(1, 'Question is required'),
    type: z.enum(['name', 'email', 'phone', 'text', 'radio', 'dropdown', 'checkbox']),
    options: z.array(questionOptionSchema).optional(),
});

export const questionsSchema = z.array(questionObjectSchema);

export type QuestionFormData = z.infer<typeof questionsSchema>;
export type QuestionSectionValidation = ReturnType<typeof useForm<QuestionFormData>>;

export const useQuestionSectionValidation = (): QuestionSectionValidation => {
    return useForm<QuestionFormData>({
        resolver: zodResolver(questionsSchema),
        defaultValues: [],
        mode: 'onChange',
    });
};
